
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { tuple_type, array_type, anonRecord_type, float64_type, int32_type, option_type, bool_type, record_type, list_type, class_type, string_type, union_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, FormState_$reflection, CustomerConfiguration_$reflection, ProcedureTemplateStepId_$reflection, RequestedValue$1_$reflection, ProcedureId_$reflection } from "../../../Shared/Shared.js";
import { StoredFileDto_$reflection, ProcedureEmail_SubmittedRecipient_$reflection, ProcedureReminderCompletionEntry_$reflection, ProcedureTemplateStepElementType_$reflection, DTO_WriteProcedureStepDto_$reflection, DTO_ProcedureFormDto_$reflection, DTO_ProcedureTemplateTestElementDto_$reflection } from "../../../Shared/Procedure.js";
import { PropertyConfiguration_$reflection } from "../../../Shared/PropertyConfiguration.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";

export class FileType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Signature", "Image"];
    }
}

export function FileType_$reflection() {
    return union_type("Widgets.Procedure.Form.Types.FileType", [], FileType, () => [[], []]);
}

export class StepFiles extends Record {
    constructor(StepId, Type, Files) {
        super();
        this.StepId = StepId;
        this.Type = Type;
        this.Files = Files;
    }
}

export function StepFiles_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.StepFiles", [], StepFiles, () => [["StepId", string_type], ["Type", FileType_$reflection()], ["Files", list_type(class_type("Browser.Types.File", undefined))]]);
}

export class InspectionDocumentFile extends Record {
    constructor(File, Name, Description, IsVisibleForUserRole) {
        super();
        this.File = File;
        this.Name = Name;
        this.Description = Description;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
    }
}

export function InspectionDocumentFile_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.InspectionDocumentFile", [], InspectionDocumentFile, () => [["File", class_type("Browser.Types.File", undefined)], ["Name", string_type], ["Description", string_type], ["IsVisibleForUserRole", bool_type]]);
}

export class InspectionDocumentEntry extends Record {
    constructor(ElementId, Files) {
        super();
        this.ElementId = ElementId;
        this.Files = Files;
    }
}

export function InspectionDocumentEntry_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.InspectionDocumentEntry", [], InspectionDocumentEntry, () => [["ElementId", string_type], ["Files", list_type(InspectionDocumentFile_$reflection())]]);
}

export class DocumentUploadFile extends Record {
    constructor(File, Name, Description, IsVisibleForUserRole) {
        super();
        this.File = File;
        this.Name = Name;
        this.Description = Description;
        this.IsVisibleForUserRole = IsVisibleForUserRole;
    }
}

export function DocumentUploadFile_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.DocumentUploadFile", [], DocumentUploadFile, () => [["File", class_type("Browser.Types.File", undefined)], ["Name", string_type], ["Description", string_type], ["IsVisibleForUserRole", bool_type]]);
}

export class DocumentUploadEntry extends Record {
    constructor(ElementId, Files) {
        super();
        this.ElementId = ElementId;
        this.Files = Files;
    }
}

export function DocumentUploadEntry_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.DocumentUploadEntry", [], DocumentUploadEntry, () => [["ElementId", string_type], ["Files", list_type(DocumentUploadFile_$reflection())]]);
}

export class PhotoUploadFile extends Record {
    constructor(File, Url) {
        super();
        this.File = File;
        this.Url = Url;
    }
}

export function PhotoUploadFile_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.PhotoUploadFile", [], PhotoUploadFile, () => [["File", class_type("Browser.Types.File", undefined)], ["Url", option_type(string_type)]]);
}

export class PhotoUploadEntry extends Record {
    constructor(ElementId, Files) {
        super();
        this.ElementId = ElementId;
        this.Files = Files;
    }
}

export function PhotoUploadEntry_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.PhotoUploadEntry", [], PhotoUploadEntry, () => [["ElementId", string_type], ["Files", list_type(PhotoUploadFile_$reflection())]]);
}

export class ProcedureFormMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Live", "Test"];
    }
}

export function ProcedureFormMode_$reflection() {
    return union_type("Widgets.Procedure.Form.Types.ProcedureFormMode", [], ProcedureFormMode, () => [[["Item", ProcedureId_$reflection()]], [["elements", list_type(DTO_ProcedureTemplateTestElementDto_$reflection())]]]);
}

export class State extends Record {
    constructor(Mode, ProcedureForm, SelectedTemplateStep, WriteProcedureStepDto, StepFiles, InspectionDocuments, DocumentUploads, PhotoUploads, PropertyConfigurations, CustomerConfiguration, Storages, FormState, IsProcedureCompleted, IsProcedureCancelled) {
        super();
        this.Mode = Mode;
        this.ProcedureForm = ProcedureForm;
        this.SelectedTemplateStep = SelectedTemplateStep;
        this.WriteProcedureStepDto = WriteProcedureStepDto;
        this.StepFiles = StepFiles;
        this.InspectionDocuments = InspectionDocuments;
        this.DocumentUploads = DocumentUploads;
        this.PhotoUploads = PhotoUploads;
        this.PropertyConfigurations = PropertyConfigurations;
        this.CustomerConfiguration = CustomerConfiguration;
        this.Storages = Storages;
        this.FormState = FormState;
        this.IsProcedureCompleted = IsProcedureCompleted;
        this.IsProcedureCancelled = IsProcedureCancelled;
    }
}

export function State_$reflection() {
    return record_type("Widgets.Procedure.Form.Types.State", [], State, () => [["Mode", ProcedureFormMode_$reflection()], ["ProcedureForm", RequestedValue$1_$reflection(DTO_ProcedureFormDto_$reflection())], ["SelectedTemplateStep", option_type(ProcedureTemplateStepId_$reflection())], ["WriteProcedureStepDto", DTO_WriteProcedureStepDto_$reflection()], ["StepFiles", list_type(StepFiles_$reflection())], ["InspectionDocuments", list_type(InspectionDocumentEntry_$reflection())], ["DocumentUploads", list_type(DocumentUploadEntry_$reflection())], ["PhotoUploads", list_type(PhotoUploadEntry_$reflection())], ["PropertyConfigurations", list_type(PropertyConfiguration_$reflection())], ["CustomerConfiguration", RequestedValue$1_$reflection(CustomerConfiguration_$reflection())], ["Storages", list_type(Storage_$reflection())], ["FormState", FormState_$reflection()], ["IsProcedureCompleted", bool_type], ["IsProcedureCancelled", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetTextValue", "SetIntValue", "SetFloatValue", "OnSelectBoolValue", "OnChangeSingleSelectValue", "OnChangeMultiSelectValue", "OnChangeDateTimeValue", "OnChangeInspectionResultValue", "OnChangeInspectionResultComment", "SetCustomFieldValue", "OnSelectToolStateChangeValue", "OnChangeToolStateChangeComment", "OnSelectStorageTransferStorage", "OnChangeStorageTransferSpace", "UpdateReminderCompletionEntry", "RemoveReminderCompletionEntry", "SetEmailRecipients", "AddInspectionDocument", "RemoveInspectionDocument", "SetInspectionDocumentName", "SetInspectionDocumentDescription", "ToggleInspectionDocumentIsVisibleForUserRole", "AddDocumentUpload", "RemoveDocumentUpload", "SetDocumentUploadName", "SetDocumentUploadDescription", "ToggleDocumentUploadIsVisibleForUserRole", "AddFile", "DeleteFile", "SetPhotos", "UploadPhotos", "PhotosUploaded", "SelectTemplateStep", "OnSave", "SaveForm", "UploadFiles", "FilesUploaded", "ChecklistExecutionSaved", "CreateStep", "UploadInspectionDocuments", "InspectionDocumentsUploaded", "PrepareDto", "ValidateWithDto", "StepValidated", "CreateStepWithDto", "StepCreated", "ProcedureFormFetched", "PropertyConfigurationsFetched", "CustomerConfigurationFetched", "StoragesFetched", "CompleteProcedure", "ProcedureCompleted", "CancelProcedure", "ProcedureCanceled", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Widgets.Procedure.Form.Types.Msg", [], Msg, () => [[["procedureTemplateStepElementId", string_type], ["value", string_type]], [["procedureTemplateStepElementId", string_type], ["value", int32_type]], [["procedureTemplateStepElementId", string_type], ["value", option_type(float64_type)]], [["stepId", string_type], ["value", bool_type]], [["stepId", string_type], ["value", option_type(anonRecord_type(["label", string_type], ["value", string_type]))], ["elementType", ProcedureTemplateStepElementType_$reflection()]], [["stepId", string_type], ["value", option_type(array_type(anonRecord_type(["label", string_type], ["value", string_type])))]], [["stepId", string_type], ["value", option_type(class_type("System.DateTime"))]], [["stepId", string_type], ["value", option_type(anonRecord_type(["label", string_type], ["value", string_type]))]], [["stepId", string_type], ["value", string_type]], [["procedureTemplateStepElementId", string_type], ["value", string_type]], [["procedureTemplateStepElementId", string_type], ["value", option_type(string_type)]], [["procedureTemplateStepElementId", string_type], ["value", string_type]], [["procedureTemplateStepElementId", string_type], ["value", option_type(string_type)]], [["procedureTemplateStepElementId", string_type], ["value", string_type]], [["procedureTemplateStepElementId", string_type], ["entry", ProcedureReminderCompletionEntry_$reflection()]], [["procedureTemplateStepElementId", string_type], ["reminderId", string_type]], [["procedureTemplateStepElementId", string_type], ["recipients", list_type(ProcedureEmail_SubmittedRecipient_$reflection())]], [["stepId", string_type], ["files", list_type(class_type("Browser.Types.File", undefined))]], [["stepId", string_type], ["index", int32_type]], [["stepId", string_type], ["index", int32_type], ["name", string_type]], [["stepId", string_type], ["index", int32_type], ["description", string_type]], [["stepId", string_type], ["index", int32_type]], [["stepId", string_type], ["files", list_type(class_type("Browser.Types.File", undefined))]], [["stepId", string_type], ["index", int32_type]], [["stepId", string_type], ["index", int32_type], ["name", string_type]], [["stepId", string_type], ["index", int32_type], ["description", string_type]], [["stepId", string_type], ["index", int32_type]], [["stepId", string_type], ["value", class_type("Browser.Types.File", undefined)], ["Item3", FileType_$reflection()]], [["stepId", string_type], ["value", class_type("Browser.Types.File", undefined)]], [["elementId", string_type], ["files", list_type(class_type("Browser.Types.File", undefined))]], [], [["Item", ClientApiResponse$1_$reflection(list_type(tuple_type(int32_type, string_type)))]], [["stepId", option_type(ProcedureTemplateStepId_$reflection())]], [], [], [], [["Item", ClientApiResponse$1_$reflection(list_type(StoredFileDto_$reflection()))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [], [["Item", ClientApiResponse$1_$reflection(list_type(tuple_type(string_type, string_type)))]], [], [["Item", DTO_WriteProcedureStepDto_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", DTO_WriteProcedureStepDto_$reflection()]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", DTO_ProcedureFormDto_$reflection()]], [["Item", list_type(PropertyConfiguration_$reflection())]], [["Item", CustomerConfiguration_$reflection()]], [["Item", list_type(Storage_$reflection())]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

